import { html } from '@ni/fast-element';
import type { ThemeProvider } from '.';

export const template = html<ThemeProvider>`<slot></slot>`;
